import styled from 'styled-components';

export const AccordionPaginationWrapper = styled.div`
.page-link{
    color: white;
    background-color: #647f19;
}
.page-link:focus{
    box-shadow: 0 0 0 .10rem #b1ba8e;
}
.accordion-item{
    border: 1px solid #b1ba8e;
}
.accordion-button:focus{
    box-shadow: 0 0 0 .20rem #b1ba8e;
}
`;
